/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect, useContext } from 'react';
import { Button, Checkbox, Divider, Grid, Slide, Modal } from '@material-ui/core';
import { object, func } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { splitAndCapitalize } from '../Helpers/Helpers';
import filtericon from '../Assets/filtericon.svg';
import filterCloseIcon from '../Assets/filterCloseIcon.svg'
import { RecipientBookContext } from '../../Common/Context/RecipientBookContext';

const useStyles = makeStyles(() => ({
    dialogHeader: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '14px',
        '& h3': {
            fontSize: '20px',
            margin: '0px 10px 0px 0px',
        },
        '& span': {
            height: '18px',
            width: '24px',
        },
    },
    arrowContainer: {
        width: 'fit-content',
    },
    filterBtn: {
        border: '1px solid black !important',
        color: '#000000  !important',
        textTransform: 'capitalize  !important',
        padding: '7px 20px 7px 20px  !important',
        fontSize: '14px  !important',
        fontWeight: '700  !important',
        backgroundColor: '#FFFFFF !important'
    },
    modalBrackdropProps: {
        bottom: 'unset !important',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'flex-end',
        '@media screen and (max-width: 500px)': {
            height: '100%',
            overflow: 'auto'
        }
    },
    modalContainer: {
        backgroundColor: 'white', 
        maxWidth: '490px', 
        padding: '0px 65px',
        overflow: 'scroll',
        '@media screen and (max-width: 500px)': {
            padding: '0px 15px',
        }
    },
    ctaGrid: {
        '@media screen and (max-width: 500px)': {
            paddingLeft: '8px !important'
        }
    },
    ctaBtn: {
        width: '107px', 
        height: '56px', 
        padding: '15px 29.5px'
    },
    closeIcon: {
        textAlign: 'end', 
        paddingTop: '10px',  
        backgroundColor: 'white', 
        maxWidth: '490px', 
        paddingRight: '10px',
        cursor: 'pointer',
    },
    btnContainer: {
        paddingBottom: '68px', 
        paddingTop: '16px'
    },
    slideInnerContainer: {
        height: '100vh',
        '@media screen and (min-width: 1000px)': {
            justifyContent: 'center',
        },
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
    },
    filterCategoryTitle: {
        margin: '12px 0px',
    },
}));

const FilterRecipientBookModal = ({ classes: globalClasses, recipientState }) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const { recipientsCopy, setRecipientsCopy, setRecipientState } = useContext(RecipientBookContext);

    const getFilterSelectionMonths = () => {
        const currentDate = new Date();
        let currentMonth = currentDate.getMonth();
        const formatMonth = (month) => (month < 10 ? `0${month}` : String(month));
    
        const futureMonths = {
            currentMonth: [formatMonth(currentMonth + 1)], // Adding 1 to match month numbering (January is 0)
            nextMonth: [formatMonth((currentMonth + 1) % 12 + 1)], // Adding 1 to match month numbering
            threeMonthsFromNow: [],
            sixMonthsFromNow: [],
            twelveMonthsFromNow: [],
        };
    
        // Calculate the next 3/6/12 months
        for (let i = 1; i <= 12; i++) {
            const nextMonth = (currentMonth + i) % 12 + 1;
            if (i <= 3) {
                futureMonths['threeMonthsFromNow'].push(formatMonth(nextMonth));
            }
            if (i <= 6) {
                futureMonths['sixMonthsFromNow'].push(formatMonth(nextMonth));
            }
            if (i <= 12) {
                futureMonths['twelveMonthsFromNow'].push(formatMonth(nextMonth));
            }
        }
    
        return futureMonths;
    };
    
    const filterMonthsRange = getFilterSelectionMonths();

    const [selectedRelationship, setSelectedRelationship] = useState({
        client: {
            id: '23',
            checked: false,
        },
        colleague: {
            id: '22',
            checked: false,
        },
        family: {
            id: ['1', '2', '3', '4', '5', '6', '7', '8', '10', '20', '14', '15', '21'],
            checked: false,
        },
        boyfriend: {
            id: '16',
            checked: false,
        },
        girlfriend: {
            id: '17',
            checked: false,
        },
        friend: {
            id: '18',
            checked: false,
        },
        others: {
            id: '19',
            checked: false,
        },
    });

    const [selectedOccasion, setSelectedOccasion] = useState({
        anniversary: {
            id: '1',
            checked: false,
        },
        birthday: {
            id: '2',
            checked: false,
        },
        wedding: {
            id: '3',
            checked: false,
        },
        justBecause: {
            id: '4',
            checked: false,
        },
        valentinesDay: {
            id: '5',
            checked: false,
        },
        easter: {
            id: '6',
            checked: false,
        },
        mothersDay: {
            id: '7',
            checked: false,
        },
        fathersDay: {
            id: '8',
            checked: false,
        },
        thanksgiving: {
            id: '9',
            checked: false,
        },
        christmas: {
            id: '10',
            checked: false,
        },
        parentsDay: {
            id: '11',
            checked: false,
        },
        friendshipDay: {
            id: '12',
            checked: false,
        },
        newYear: {
            id: '13',
            checked: false,
        },
        halloween: {
            id: '14',
            checked: false,
        },
        veteransDay: {
            id: '15',
            checked: false,
        },
        memorialDay: {
            id: '16',
            checked: false,
        },
        cincoDeMayo: {
            id: '17',
            checked: false,
        },
        hannukah: {
            id: '18',
            checked: false,
        },
        bossDay: {
            id: '19',
            checked: false,
        },
        eid: {
            id: '20',
            checked: false,
        },
        diwali: {
            id: '21',
            checked: false,
        },
    });

    const [selectedReminderTimeframe, setSelectedReminderTimeframe] = useState({
        thisMonth: {
            id: filterMonthsRange.currentMonth,
            checked: false,
        },
        nextMonth: {
            id: filterMonthsRange.nextMonth,
            checked: false,
        },
        next3Month: {
            id: filterMonthsRange.threeMonthsFromNow,
            checked: false,
        },
        next6Month: {
            id: filterMonthsRange.sixMonthsFromNow,
            checked: false,
        },
        next12Month: {
            id: filterMonthsRange.twelveMonthsFromNow,
            checked: false,
        },
    });

    const isRelationshipChecked = Object.values(selectedRelationship).some((relationship) => relationship.checked);
    const isOccasionChecked = Object.values(selectedOccasion).some((occasion) => occasion.checked);
    const isSelectedReminderTimeframeChecked = Object.values(selectedReminderTimeframe).some((timeframe) => timeframe.checked);

    const filterDataAndCloseModal = () => {

        if (recipientState?.addressBookResponse?.addressList?.length === 0) {
            setRecipientState({ ...recipientsCopy });
            setOpen(false);
            return;
        }

        if (!isRelationshipChecked && !isOccasionChecked && !isSelectedReminderTimeframeChecked) {
            // Resetting global recipientState with recipientsCopy when no filter options are selected
            setRecipientState({ ...recipientsCopy });
            setOpen(false);
            return;
        }
        
        // We are looping over recipientsCopy
        const filterResults = recipientsCopy?.addressBookResponse?.addressList?.filter((recipient) => {
            // Relationship + Occasion + Reminder time filter
            if (isRelationshipChecked && isOccasionChecked && isSelectedReminderTimeframeChecked) {
                return Object.values(selectedRelationship)?.some((relationship) => relationship.checked && (Array.isArray(relationship.id) ? relationship.id?.includes(recipient.relationship) : (relationship.id === recipient.relationship))) &&
                recipient.occasions?.some((occasion) => Object.values(selectedOccasion)?.some((occ) => occ.checked && (occ.id === occasion.occasion) && 
                Object.values(selectedReminderTimeframe)?.some((reminder) => (occasion.subscribedEmail || occasion.subscribedPhone) && reminder.checked && reminder.id?.includes(occasion?.dateMM))));
            }
            
            // Relationship + Occasion only filter
            if (isRelationshipChecked && isOccasionChecked && !isSelectedReminderTimeframeChecked) {
                return Object.values(selectedRelationship)?.some((relationship) => relationship.checked && (Array.isArray(relationship.id) ? relationship.id?.includes(recipient.relationship) : (relationship.id === recipient.relationship))) &&
                recipient.occasions?.some((occasion) => Object.values(selectedOccasion)?.some((occ) => occ.checked && (occ.id === occasion.occasion)));
            }

            // Relationship + Reminder time only filter
            if (isRelationshipChecked && !isOccasionChecked && isSelectedReminderTimeframeChecked) {
                return Object.values(selectedRelationship)?.some((relationship) => relationship.checked && (Array.isArray(relationship.id) ? relationship.id?.includes(recipient.relationship) : (relationship.id === recipient.relationship))) &&
                recipient.occasions?.some((occasion) => Object.values(selectedReminderTimeframe)?.some((reminder) => (occasion.subscribedEmail || occasion.subscribedPhone) && reminder.checked && reminder.id?.includes(occasion?.dateMM)));
            }

            // Occasion and Reminder time only filter
            if (!isRelationshipChecked && isOccasionChecked && isSelectedReminderTimeframeChecked) {
                return recipient.occasions?.some((occasion) => Object.values(selectedOccasion)?.some((occ) => occ.checked && (occ.id === occasion.occasion)) && 
                Object.values(selectedReminderTimeframe)?.some((reminder) => (occasion.subscribedEmail || occasion.subscribedPhone) && reminder.checked && reminder.id?.includes(occasion?.dateMM)));
            }

            // Relationship only filter
            if (isRelationshipChecked && !isOccasionChecked && !isSelectedReminderTimeframeChecked) {
                return Object.values(selectedRelationship)?.some((relationship) => relationship.checked && (Array.isArray(relationship.id) ? relationship.id?.includes(recipient.relationship) : (relationship.id === recipient.relationship)));
            }

            // Occasion only filter
            if (!isRelationshipChecked && isOccasionChecked && !isSelectedReminderTimeframeChecked) {
                return recipient.occasions?.some((occasion) => Object.values(selectedOccasion)?.some((occ) => occ.checked && (occ.id === occasion.occasion)));
            }


            // Reminder time only filter
            if (!isRelationshipChecked && !isOccasionChecked && isSelectedReminderTimeframeChecked && recipient?.occasions?.length) {
                return recipient.occasions?.some((occasion) => Object.values(selectedReminderTimeframe)?.some((reminder) => (occasion?.subscribedEmail || occasion?.subscribedPhone) && reminder?.checked && reminder?.id?.includes(occasion?.dateMM)));
            }
            
            return false;
        })
        
        if (filterResults.length) {
            // We are using the recipientsCopy global state which is 1:1 with the recipientState when it comes to contacts
            setRecipientState({ ...recipientsCopy, addressBookResponse: {...recipientsCopy.addressBookResponse, addressList: [...filterResults], totalEntries: filterResults.length } });    
        } else {
            setRecipientState({ ...recipientsCopy, addressBookResponse: {...recipientsCopy.addressBookResponse, addressList: [], totalEntries: 0 } });    
        }
        setOpen(false);
    };

    const FilterCheckboxGroup = ({ data, selectedValues, onChange }) => (
        <Grid container xs={12}>
            {Object.entries(data).map(([key]) => (
                <Grid item xs={6} key={key} onClick={onChange(key)}>
                    <div>
                        <Checkbox
                            icon={<span className={globalClasses.customCheckbox} />}
                            checkedIcon={<span className={globalClasses.customCheckedCheckbox} />}
                            checked={selectedValues[key].checked}
                            onChange={onChange(key)}
                            color="primary"
                            classes={{ root: globalClasses.facetsCheckbox }}
                        />
                        {splitAndCapitalize(key)}
                    </div>
                </Grid>
            ))}
        </Grid>
    );

    const handleRelationshipChange = (filter) => (e) => {
        setSelectedRelationship({
            ...selectedRelationship,
            [filter]: { ...selectedRelationship[filter], checked: e.target.checked },
        });
    };

    const handleOccasionChange = (occasion) => (e) => {
        setSelectedOccasion({
            ...selectedOccasion,
            [occasion]: { ...selectedOccasion[occasion], checked: e.target.checked },
        });
    };

    const handleUpcomingRemindersChange = (reminder) => (e) => {
        setSelectedReminderTimeframe({
            ...selectedReminderTimeframe,
            [reminder]: { ...selectedReminderTimeframe[reminder], checked: e.target.checked },
        });
    };

    const clearAll = () => {
        setSelectedRelationship({
            client: { ...selectedRelationship.client, checked: false },
            colleague: { ...selectedRelationship.colleague, checked: false },
            family: { ...selectedRelationship.family, checked: false },
            boyfriend: { ...selectedRelationship.boyfriend, checked: false },
            girlfriend: { ...selectedRelationship.girlfriend, checked: false },
            friend: { ...selectedRelationship.friend, checked: false },
            others: { ...selectedRelationship.others, checked: false },
        });

        setSelectedOccasion({
            anniversary: { ...selectedOccasion.anniversary, checked: false },
            birthday: { ...selectedOccasion.birthday, checked: false },
            wedding: { ...selectedOccasion.wedding, checked: false },
            justBecause: { ...selectedOccasion.justBecause, checked: false },
            valentinesDay: { ...selectedOccasion.valentinesDay, checked: false },
            easter: { ...selectedOccasion.easter, checked: false },
            mothersDay: { ...selectedOccasion.mothersDay, checked: false },
            fathersDay: { ...selectedOccasion.fathersDay, checked: false },
            thanksgiving: { ...selectedOccasion.thanksgiving, checked: false },
            christmas: { ...selectedOccasion.christmas, checked: false },
            parentDay: { ...selectedOccasion.parentsDay, checked: false },
            friendshipDay: { ...selectedOccasion.parentsDay, checked: false },
            newyear: { ...selectedOccasion.newyear, checked: false },
            halloween: { ...selectedOccasion.newyear, checked: false },
            veteransDay: { ...selectedOccasion.veteransDay, checked: false },
            memorialDay: { ...selectedOccasion.memorialDay, checked: false },
            cincoDeMayo: { ...selectedOccasion.cincoDeMayo, checked: false },
            hannukah: { ...selectedOccasion.hannukah, checked: false },
            bossDay: { ...selectedOccasion.bossDay, checked: false },
            eid: { ...selectedOccasion.eid, checked: false },
            diwali: { ...selectedOccasion.diwali, checked: false },
        });

        setSelectedReminderTimeframe({
            thisMonth: { ...selectedReminderTimeframe.thisMonth, checked: false },
            nextMonth: { ...selectedReminderTimeframe.nextMonth, checked: false },
            next3Month: { ...selectedReminderTimeframe.next3Month, checked: false },
            next6Month: { ...selectedReminderTimeframe.next6Month, checked: false },
            next12Month: { ...selectedReminderTimeframe.next12Month, checked: false },
        });
    };

    const closeModal = () => {
        clearAll();
        setOpen(false);
    };


    // Make a copy of the latest recipients every time component loads
    useEffect(() => {
        // Update recipients copy state only when the recipient state updates
        // AND when no filter options are selected
        if ((recipientState?.addressBookResponse?.addressList?.length !== recipientsCopy?.addressBookResponse?.addressList.length) && (!isRelationshipChecked && !isOccasionChecked && !isSelectedReminderTimeframeChecked)) {
            setRecipientsCopy({ ...recipientState })
        }
    }, [recipientState, recipientsCopy])
    
    return (
        <div>
            <Button
                className={classes.filterBtn}
                onClick={() => setOpen(true)}
            >
                Filter
            </Button>
            <Modal open={open}
                className={classes.modalBrackdropProps}
                onClose={() => setOpen(false)}
            >
                <Slide  direction="left" in={open} mountOnEnter unmountOnExit>
                    <div className={classes.slideInnerContainer}>
                        <div className={classes.closeIcon} onClick={closeModal} role="button" tabIndex={0} onKeyDown={() => { }}><span><img src={filterCloseIcon} alt="close icon" /></span></div>
                        <div className={classes.modalContainer}>
                            <div className={classes.dialogHeader}>
                                <h3>Filter</h3>
                                <span><img src={filtericon} alt="filter icon" /></span>
                            </div>
                            <Divider />
                            <div>
                                <h3 className={classes.filterCategoryTitle}>Relationship Type</h3>
                                <FilterCheckboxGroup
                                    data={selectedRelationship}
                                    selectedValues={selectedRelationship}
                                    onChange={handleRelationshipChange}
                                />
                            </div>
                            <Divider />
                            <div>
                                <h3 className={classes.filterCategoryTitle}>Reminder Occasions</h3>
                                <FilterCheckboxGroup
                                    data={selectedOccasion}
                                    selectedValues={selectedOccasion}
                                    onChange={handleOccasionChange}
                                />
                            </div>
                            <Divider />
                            <div>
                                <h3 className={classes.filterCategoryTitle}>Upcoming Reminders</h3>
                                <FilterCheckboxGroup
                                    data={selectedReminderTimeframe}
                                    selectedValues={selectedReminderTimeframe}
                                    onChange={handleUpcomingRemindersChange}
                                />
                            </div>
                        <Grid container justifyContent='center' spacing={2} className={classes.btnContainer}>
                            <Grid item lg={4} className={classes.ctaGrid}>    
                                <Button
                                    fullWidth
                                    className={classes.ctaBtn}
                                    variant="outlined"
                                    color="primary"
                                    onClick={closeModal}
                                    >
                                    Close
                                </Button>
                            </Grid>
                            <Grid item lg={4} className={classes.ctaGrid}>
                                <Button
                                    fullWidth
                                    className={classes.ctaBtn}
                                    variant="outlined"
                                    color="primary"
                                    onClick={clearAll}
                                    >
                                    Clear
                                </Button>
                            </Grid>
                            <Grid item lg={4} className={classes.ctaGrid}>
                                <Button 
                                    fullWidth
                                    className={classes.ctaBtn}
                                    variant="contained" 
                                    color="primary" 
                                    onClick={() => filterDataAndCloseModal()}
                                >
                                    Apply
                                </Button>
                            </Grid>
                        </Grid>
                        </div>
                    </div>
                </Slide>
            </Modal>
        </div>
    );
};

FilterRecipientBookModal.propTypes = {
    classes: object.isRequired,
    setRecipientState: func.isRequired,
};

FilterRecipientBookModal.defaultProps = {
    setRecipientState: () => {},
};

export default FilterRecipientBookModal;
